import NoPatients from "./NoPatients";

export default NoPatients;